import { TriangleAlert } from 'lucide-react';

import { Badge } from '@nesso/ui/primitives/badge';

type Props = {
    variant: 'verified' | 'unverified';
};

const config = {
    verified: {
        label: 'Verified',
        icon: null,
        badgeVariant: 'outline' as const,
    },
    unverified: {
        label: 'Verification needed',
        icon: TriangleAlert,
        badgeVariant: 'warning' as const,
    },
};

export function ProfileEmailVerificationBadge({ variant }: Props) {
    const { label, icon: Icon, badgeVariant } = config[variant];

    return (
        <Badge variant={badgeVariant}>
            {Icon && <Icon className="size-3" />}
            {label}
        </Badge>
    );
}
